import React from 'react';
import { Link } from 'react-router-dom';

const Exercise = () => {
  return (
    <div className="cardio-page page-container">
      <h1>Exercise and Fitness</h1>
       {/* Include the image */}
     
      <img
      src="/images/wf-exercise.webp"
      alt="Person doing cardio exercise"
      className="page-image"
      width="330"
    />


            
      <p>Welcome to the Exercise and Fitness section of Wholeness Forward.</p>
      <p>
        Physical activity is a cornerstone of a healthy lifestyle. It improves not only your physical health but also your mental well-being and overall quality of life. This section provides a structured overview of exercise and fitness, with subtopics to explore based on your goals, interests, and needs.
      </p>

      <h2>Subtopics</h2>

      {/* Subtopic 1: Types of Exercise */}
      <div className="subtopic-section">
        <h3>1. Types of Exercise</h3>
        <p>
          Explore the diverse range of exercises and how they can be tailored to meet your specific fitness goals.
        </p>
        <ul>
          <li><Link to="/exercise/cardio">Cardio/Endurance Training</Link></li>
          <li><Link to="/exercise/strength">Strength Training</Link></li>
          <li><Link to="/exercise/flexibility">Flexibility and Stretching</Link></li>
        </ul>
      </div>

      <hr />

      {/* Intro Video Section */}
      <div>
        <h2>Intro Videos</h2>
        <p>
          Discover what happens to your body when you start exercising regularly and how it transforms over time.
        </p>

        {/* Video 1 */}
        <div>
          <h3>What Happens To Your Body When You Start Exercising Regularly</h3>
          <p>
            <strong>Source:</strong> Tech Insider <br />
            <strong>Length:</strong> 4:18 <br />
            This video delves into the short-term and long-term effects of regular exercise on the human body.
          </p>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/rBUjOY12gJA?start=187" // Start time included
            title="What Happens To Your Body When You Start Exercising Regularly"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>

        <hr />

        {/* Video 2 */}
        <div>
          <h3>How to Use Exercise to Improve Your Brain’s Health, Longevity & Performance</h3>
          <p>
            <strong>Source:</strong> Andrew Huberman <br />
            <strong>Length:</strong> 1:49:32 <br />
            This podcast explores the profound impact of physical activity on brain health, focus, and cognitive function.
          </p>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/J2oqi41dCNc"
            title="How Exercise Enhances Brain Health and Focus - Andrew Huberman"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>

      <hr />

      {/* Forum Section */}
      <div style={{ marginTop: "30px", padding: "20px" }}>
        <h2>Join the Discussion</h2>
        <p>
          Have questions or insights about exercise and fitness? Join our forum to connect with others who are exploring this topic.
        </p>
        <a
          href="/forum/Exercise"
          style={{
            display: "inline-block",
            backgroundColor: "#46656f",
            color: "white",
            padding: "10px 15px",
            borderRadius: "5px",
            textDecoration: "none",
            fontWeight: "bold",
          }}
        >
          Go to Exercise Forum
        </a>
      </div>
    </div>
  );
};

export default Exercise;
